import contenteditableTypes from '../constants/contenteditable-types';
import getMatchedContenteditableType from '../helpers/get-matched-contenteditable-type';

const canBeSimpleEdited = (node) => {
  const contenteditableType = getMatchedContenteditableType(node);
  return contenteditableType === contenteditableTypes.SIMPLE;
};

export default canBeSimpleEdited;
